import request from '../utils/request';

export const getExplorerStats = () => {
  return request.get('/api/explorer/stats');
};

export const getBlocks = (params) => {
  return request.get('/api/explorer/blocks', { params });
};

export const getBlock = (id) => {
  return request.get(`/api/explorer/blocks/${id}`);
};

export const getTransactions = (params) => {
  return request.get('/api/explorer/transactions', { params });
};

export const getTransaction = (txid) => {
  return request.get(`/api/explorer/transactions/${txid}`);
};

export const getAddresses = (params) => {
  return request.get('/api/explorer/addresses', { params });
};

export const getAssets = (params) => {
  return request.get('/api/explorer/assets', { params });
};

export const searchExplorer = (query) => {
  return request.get('/api/explorer/search', { params: { q: query } });
};

export const getChainStats = (chainId) => {
  return request.get(`/api/explorer/chain-stats/${chainId}`);
};
